
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"30","height":"21","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#FFF","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M16.5 1.5h12M13.5 7.5h15M9.474 13.5H28.5M1.5 19.5h27"}})])])
      }
    
      }
    